<script>
import Base from "@/components/RequestDetailsForDefaultVue/PrePayment.vue";

export default {
  name: "CustomerServiceFilesPrePayment",
  extends: Base,
};
</script>
